export default __webpack_public_path__ + "static/media/4.64fc6d5d.jpg";